<script setup>
import { ref, onBeforeMount } from 'vue';
import API from '../../../api/api-main';
import { transaction } from '@/stores/transaction';
import { format } from 'date-fns';
import { getCurrentInstance } from 'vue';
import { useToast } from 'primevue/usetoast';
import { useUserStore } from '@/stores/user';
import { render } from 'primevue/inputotp/inputotp.cjs';
import { renderStatus } from '../../../helper/renderStatus';

const permissions = useUserStore();
const { proxy } = getCurrentInstance();
const toast = useToast();
const Transaction = transaction();
const selectedInvoice = ref('');
const isLoading = ref(false);
const dialog = ref(false);
const DataInvoice = ref([]);
const selectedProduct = ref('');
const fnT = Transaction.$state;

onBeforeMount(() => {
    document.addEventListener('keydown', function (event) {
        if (event.key === 'F6') {
            event.preventDefault();
            fnT.data[fnT.active].Customer = '';
            setTimeout(() => {
                document.getElementById('AutoCompleteInvoice').querySelector('input').focus();
                document.getElementById('AutoCompleteInvoice').querySelector('input').select();
            }, 100);
        }
    });
});

const fetchAllReceiptPO = async (key) => {
    if (!key.startsWith('HD')) {
        const lengthNum = key.length;
        if (lengthNum < 7) {
            const renderString = (length) => {
                let str = '';
                for (let index = 0; index < length; index++) {
                    str += '0';
                }
                return str;
            };
            key = renderString(7 - lengthNum) + key;
        }
    }
    try {
        const { data } = await API.get(`${fnT.data[fnT.active].nameUrl}/invoiceCode?invoiceCode=${key.toUpperCase()}`);
        if (data.item) {
            if (data.item.canceled || data.item.canceledInvoice) return;

            if (data.item.canceledIssue && permissions.checkPermissions('Pos_Selling_Create')) return;

            if (data.item.isIssue && !data.item.canceledIssue && permissions.checkPermissions('Pos_Selling_Payment')) return;
            if (fnT.data[fnT.active].nameUrl == 'ARJewerly') {
            }
            selectedInvoice.value = data.item;
            fnT.data[fnT.active].payload = selectedInvoice.value;
            fnT.data[fnT.active].payload.itemDetail = fnT.data[fnT.active].payload.itemDetail.map((item) => {
                return {
                    ...item,
                    serialObj: item.serial?.length > 0 ? item.serial[0] : {}
                };
            });
            if (!fnT.data[fnT.active].payload.paymentMethod?.length) {
                fnT.data[fnT.active].payload.paymentMethod = [
                    {
                        id: 0,
                        fatherId: 0,
                        paymentMethodCode: 'Cash',
                        paymentMethodName: 'Tiền mặt',
                        amount: (fnT.data[fnT.active].payload.total || 0) + (fnT.data[fnT.active].payload?.totalTaxAmount || 0)
                    }
                ];
            }
            console.log(fnT.data[fnT.active].payload.totalTaxAmount);
            selectedInvoice.value = '';
        }
    } catch (error) {
        proxy.$notify('E', error?.response?.data?.errors || 'Không tìm thấy hóa đơn', toast);
    } finally {
        dialog.value = false;
    }
};

const clearDetailInvoice = () => {
    selectedInvoice.value = '';
    Transaction.CLEAR_DATA(fnT.active, fnT.data[fnT.active].id);
};

const openDialog = () => {
    getAll();
    dialog.value = true;
};

const getAll = async () => {
    try {
        const { data } = await API.get(`ARInvoice/getall?Page=1&PageSize=50&OrderBy=id desc`);
        DataInvoice.value = data.items;
    } catch (error) {}
};
</script>
<template>
    <div>
        <InputGroup class="w-full" v-if="!fnT.data[fnT.active].payload.id">
            <AutoComplete id="AutoCompleteInvoice" class="w-full" placeholder="Tìm kiếm hóa đơn (F6)" v-model.trim="selectedInvoice" optionLabel="invoiceCode" @complete="fetchAllReceiptPO(selectedInvoice)" />
            <InputGroupAddon @click="openDialog()">
                <i class="pi pi-book"></i>
            </InputGroupAddon>
        </InputGroup>
        <ButtonGroup class="flex" v-else>
            <Button class="pi pi-book" severity="secondary"></Button>
            <Button class="w-full" severity="secondary" :label="`Hóa đơn: ${fnT.data[fnT.active].payload.invoiceCode}`"></Button>
            <Button @click="clearDetailInvoice()" severity="secondary" icon="pi pi-times" />
        </ButtonGroup>
    </div>
    <Dialog v-model:visible="dialog" modal header="Danh sách hóa đơn" :style="{ width: '65rem' }">
        <DataTable v-model:selection="selectedProduct" :value="DataInvoice" paginator :rows="10" :rowsPerPageOptions="[10, 20, 50]" selectionMode="single" tableStyle="min-width: 50rem">
            <template #header>
                <div>
                    <InputText class="w-6" placeholder="Tìm kiếm hóa đơn"></InputText>
                </div>
            </template>
            <Column selectionMode="single" headerStyle="width: 3rem"></Column>
            <Column field="invoiceCode" header="Mã hóa đơn"></Column>
            <Column field="cardCode" header="Mã khách hàng"></Column>
            <Column field="cardName" header="Tên khách hàng"></Column>
            <Column field="status" header="Trạng thái">
                <template #body="{ data }">
                    {{ renderStatus(data) }}
                </template>
            </Column>
            <Column field="total" header="Tổng tiền (VNĐ)" style="text-align: end">
                <template #body="{ data }">
                    <span>{{ Intl.NumberFormat().format(data.total) }}</span>
                </template>
            </Column>
            <Column field="docDate" header="Ngày tạo">
                <template #body="{ data }">
                    {{ format(data.docDate, 'dd/MM/yyyy') }}
                </template>
            </Column>
        </DataTable>
        <template #footer>
            <div class="flex justify-content-end gap-2">
                <Button type="button" label="Bỏ qua" severity="secondary" @click="dialog = false"></Button>
                <Button type="button" label="Xác nhận" @click="fetchAllReceiptPO(selectedProduct.invoiceCode)"></Button>
            </div>
        </template>
    </Dialog>
    <Loading v-if="isLoading"></Loading>
</template>
